import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/registrierung")({
  beforeLoad: () => {
    throw redirect({ to: "/", search: { tab: "register" } });
  },
  component: () => null,
});
